/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * WHIS API documentation
 * This document list all APIs available for WHIS project
 * OpenAPI spec version: 1.1.15
 */
import type { WahisEtiologicalAgentDtoName } from './wahisEtiologicalAgentDtoName';

export interface WahisEtiologicalAgentDto {
  /** WAHIS etiological agent code */
  code: string;
  /** WAHIS etiological agent name (multilingual) */
  name: WahisEtiologicalAgentDtoName;
  /** Etiology type code */
  etiologyTypeCode?: string;
}
